// extracted by mini-css-extract-plugin
export default {"apAssertionsTabContainer":"ap-assertions-tab-container__ap-assertions-tab-container__pCW99","assertionContainer":"ap-assertions-tab-container__assertion-container__WFzNC"};